import { Vue, Component } from 'vue-property-decorator'
import loc from '~/utils/loc'
import NotFountSvg from '~/assets/svg/basket-not-fount.svg?inline'

@Component
export default class BasketWaitingListEmpty extends Vue {
  render () {
    return (
      <div class="basket-waiting-list-empty">
        <div class="basket-waiting-list-empty__info-block">
          <div class="basket-waiting-list-empty__content">
            <div class="basket-waiting-list-empty__info-row">
              <div class="basket-waiting-list-empty__info">
                <div class="basket-waiting-list-empty__title">
                  Лист ожидания пуст
                </div>
                <div class="basket-waiting-list-empty__description">
                  Уведомим Вас о поступлении товаров в наличие
                </div>
                <div class="basket-waiting-list-empty__btn">
                  <nuxt-link to={loc(this.$store, { name: 'catalog' })} class="button-text">
                    В каталог
                  </nuxt-link>
                </div>
              </div>
              <div class="basket-waiting-list-empty__image">
                <NotFountSvg />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
